/* eslint-disable max-len */
import React, { useContext, KeyboardEvent } from 'react';
import { Card, CardContent, Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import { RecognisedBackGround } from '../../../../../Recognition/components/RecognitionBackground';
import ProfilePic from '../../../../../../components/Common/ProfilePic';
import { feedActionContext } from '../../../..';
import { getDesignElements, planeCard } from '../../../Reusable/EventCardUtils';

const CelebrationCard = ({ data }) =>
{
	const { setFeedCardActn } = useContext(feedActionContext);
	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down(1300));
	// Utility function to get background class
	const getBackgroundClass = (templateId: string | undefined) =>
	{
		switch (templateId)
		{
			case 'T2':
				return 'recBg2';
			case 'T3':
				return 'recBg3';
			default:
				return 'recBg1';
		}
	};

	// Keyboard and mouse interaction handler
	const handleCardInteraction = (e?: KeyboardEvent | React.MouseEvent) =>
	{
		// Prevent default only for keyboard events
		if (e && 'key' in e && e.key !== 'Enter' && e.key !== ' ') return;

		// Your existing action logic
		setFeedCardActn([ 'allEventCmnt', data ]);
	};
	const msgObj = {
		2 : 'Happy Birthday',
		3 : 'Happy Wedding Anniversary',
		4 : 'Happy Work Anniversary'
	};

	// Accessibility attributes for interactive div
	const interactiveProps = {
		role         : 'button',
		tabIndex     : 0,
		'aria-label' : 'View event details',
		onClick      : handleCardInteraction,
		onKeyUp      : (e: KeyboardEvent) =>
		{
			// Support Enter and Space key for keyboard interaction
			if (e.key === 'Enter' || e.key === ' ')
			{
				handleCardInteraction(e);
			}
		}
	};

	return (
		<>
			{data?.eventType === 1
				? (<div {...interactiveProps} 	className={` flexRow brdrRadiusSM brdrBlackSM eventCardHeightSM positionRelative newsfeedShadow ${getBackgroundClass(data?.templateId)}	`} style={{ height: downSM ? '156px' : '180px' }}>
					<img
						src={RecognisedBackGround('square', data?.templateId, data?.badgeId)?.background || '/images/Recognizbadge/recognitionBg1.svg'}
						loading='lazy'
						alt='recognisesquare'
						className='eventCardWorkBg'
					/>
					<div className='flexCol pdngSM zindex'>
						<div className='flexCol'>
							<div className='flexRow'>
								<div className='flexAutoRow pdngHXS positionRelative'>
									<div className='RecbadgeImg positionRelative'>
										<img
											src={RecognisedBackGround('square', data?.templateId, data?.badgeId)?.badge || '/images/Recognizbadge/badge1.svg'}
											alt='recognisebadge'
										/>
										<div className='recAvtharImg'>
											<ProfilePic
												imagePath={`${data?.employeeId}.jpeg?t=${new Date().valueOf()}`}
												defaultImg='/images/icons/defaultUser.svg'
												alt='profile'
												className='brdrRadius50'
												from='selfProfile'
											/>
										</div>
									</div>
								</div>
								<div className='flexMinWidthCol pdngSM alignCntr justifyCntr'>
									<div className='flexRow'>
										<h3 className='recDarktGold recogniseHeadingCard ellipsisTxt firstLetter mrgnBXXS'>
											{data?.title || ''}
										</h3>
									</div>
									<div className='flexRow'>
										<span className='recDarktGold capitalTxt recognizCardSubHeadding ellipseLen2'>
											{data?.employeeData?.name || ''}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>)
				: (<Card sx={{	color: 'white', borderRadius: 4, height: 'var(--percent100)', position: 'relative', overflow: 'hidden', cursor: 'pointer' }} {...interactiveProps} >
					<Box
						alignItems='center'
						display='flex'
						sx={{
							borderRadius : 'var(--pixel8)',
							cursor       : 'pointer',
							width        : 'var(--percent100)',
							position     : 'relative',
							background   : planeCard.find((item) => item?.eventType === data?.eventType)?.src || planeCard[0]?.src,
							height       : '180px'
						}}
					>
						{/* Balloons and Cake */}
						{getDesignElements(data?.eventType, 'defaultE', false).map((item:any, index:any) => (
							<Box
								key={index}
								component='img'
								src={item?.src}
								sx={{
									position : 'absolute',
									top      : item?.top || 'auto',
									bottom   : item?.bottom || 'auto',
									left     : 'auto',
									right    : item?.right || 'auto',
									width    : `${item?.width} !important`,
									height   : `${item?.height}!important`,
									'& img'  : {
										width        : 'var(--percent100)',
										height       : 'var(--percent100)',
										objectFit    : 'cover',
										borderRadius : 'var(--pixel8)'
									}
								}}
							/>
						))}
						<CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 'var(--percent100)', position: 'relative', zIndex: 1, maxWidth: '300px' }} 					>
							<Typography variant='h6' component='div' sx={{ mb: 2, fontWeight: 'bold' }}>{msgObj[data?.eventType]}</Typography>
							<button
								style={{
									background : 'none',
									border     : 'none',
									padding    : 0,
									cursor     : 'pointer',
									display    : 'flex',
									alignItems : 'center'
								}}
								aria-label='View attendees'
							>
								<Box sx={{ width: 'var(--pixel40)', height: 'var(--pixel40)', borderRadius: '50%' }} display={'inline-flex'} border='3px solid var(--whiteColor);' alignItems='center' justifyContent='center'>
									<ProfilePic
										imagePath={`${data?.employeeId}.jpeg?t=${new Date().valueOf()}`}
										defaultImg='/images/icons/defaultUser.svg'
										alt='profile'
										className='brdrRadius50'
										from='selfProfile'
									/>
								</Box>
								<Typography
									variant='body2'
									pl={1}
									sx={{ flexGrow: 1, textAlign: 'start' }}
									color='var(--whiteColor)'
								>
									Hello {data?.employeeData?.name} {data?.title}
								</Typography>
							</button>
						</CardContent>
					</Box>
				</Card>
				)
			}
		</>
	);
};

export default CelebrationCard;